import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Stack, type SxProps, Tooltip } from "@mui/material";
import { Text } from "@src/lib/ui-react";
import { useState } from "react";

// TODO: export TextVariant from @src/lib/ui-react
type TextVariant =
  | "caption"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "body1"
  | "subtitle1"
  | "subtitle2"
  | "body2";
export interface CopyableTextProps {
  value: string;
  copyableText?: string;
  onCopyClick?: () => void;
  textVariant?: TextVariant;
  rootStackSx?: SxProps;
  showText?: boolean;
}

export function CopyableText(props: CopyableTextProps): JSX.Element {
  const {
    rootStackSx,
    copyableText,
    value,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCopyClick = () => {},
    textVariant = "body1",
    showText = true,
  } = props;
  const [isCopied, setIsCopied] = useState<boolean>(false);

  function handleCopy(): void {
    onCopyClick();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    navigator.clipboard.writeText(copyableText ?? value);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={rootStackSx}>
      {showText && <Text variant={textVariant}>{value}</Text>}
      <Tooltip title={isCopied ? "Copied!" : "Copy"}>
        {/* eslint-disable-next-line react/jsx-no-bind */}
        <IconButton edge="end" sx={{ padding: 0 }} onClick={handleCopy}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
